import { Controller } from '@hotwired/stimulus';

// Adyen dashboard components controller for Adyen Platform Experience components
// Connects to data-controller="adyen-dashboard-components"
export default class extends Controller {
  static targets = ['container'];
  static values = {
    environment: String,
    session: Object,
    type: String,
  };

  async connect() {
    try {
      const { AdyenPlatformExperience, [this.typeValue]: Component } = await import('@adyen/adyen-platform-experience-web');

      if (!Component) {
        throw new Error(`Component type "${this.typeValue}" not found`);
      }

      const core = await AdyenPlatformExperience({
        environment: this.environmentValue,
        onSessionCreate: () => this.sessionValue,
      });

      const component = new Component({ core });
      component.mount(this.containerTarget);
    } catch (error) {
      console.error(`Failed to initialize Adyen ${this.typeValue} component:`, error);
      this.showError(`Failed to load ${this.getComponentDisplayName()}. Please refresh the page.`);
    }
  }

  getComponentDisplayName() {
    const displayNames = {
      Payouts: 'payouts',
      DisputesOverview: 'disputes',
    };
    return displayNames[this.typeValue] || 'component';
  }

  showError(message) {
    this.containerTarget.innerHTML = `
      <div class="alert alert-error">
        <p>${message}</p>
      </div>
    `;
  }
}
